function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useRef, useEffect, memo, ReactNode, Ref, MouseEventHandler } from 'react';
import cn from 'classnames';
import { useForkRef } from '../../../hooks/useForkRef';
import '../../../_internal_/utils/scrollIntoViewIfNeeded';
require("./MenuItem.css");
var styles = {
  "Root": "MenuItem-module-Root_2y_",
  "Icon": "MenuItem-module-Icon_1Uu",
  "Main": "MenuItem-module-Main_ku-",
  "Description": "MenuItem-module-Description_3Nk"
};
export const cnMenuItem = cn('MenuItem');
export const MenuItem = /*#__PURE__*/memo(({
  'aria-posinset': ariaPosinset,
  'aria-setsize': ariaSetsize,
  checked,
  children,
  className,
  controlRef,
  description,
  disabled,
  id,
  innerRef,
  label,
  onChange,
  onClick,
  selected
}) => {
  const itemRef = useRef(null);
  const ownRef = useForkRef(itemRef, innerRef || controlRef);
  useEffect(() => {
    if (selected && itemRef.current) {
      const parent = itemRef.current.closest('[role="listbox"]')?.parentNode;
      if (parent && parent.scrollHeight > parent.clientHeight) {
        itemRef.current.scrollIntoViewIfNeeded();
      }
    }
  }, [selected]);
  const handleClick = useCallback(e => {
    if (onChange) {
      onChange(e, id);
    }
    if (onClick) {
      onClick(e);
    }
  }, [id, onChange, onClick]);
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-posinset": ariaPosinset,
    "aria-setsize": ariaSetsize,
    "aria-selected": selected,
    className: cn(styles.Root, [className]),
    id: id,
    role: "option",
    ref: ownRef,
    title: label,
    onClick: handleClick
  }, disabled && {
    'aria-disabled': disabled
  }, checked && {
    'aria-checked': checked
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.Main
  }, children), checked && /*#__PURE__*/React.createElement("svg", {
    height: "24",
    width: "24",
    focusable: "false",
    className: styles.Icon
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18.5c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L9,16.1L19.3,5.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-11,11C9.5,18.4,9.3,18.5,9,18.5z"
  })), description && /*#__PURE__*/React.createElement("div", {
    className: styles.Description
  }, description));
});
if (process.env.NODE_ENV !== 'production') {
  MenuItem.displayName = 'MenuItem';
}